<template>
  <div :class="{ webHeaderApp: true, webHeaderApp1: !isShow, webHeaderApp2: isShow }">
    <div class="webHeaderContentApp">
      <div class="logo2" @click="handleChange(1, '/')">
        <img src="../../assets/logo/logo.png" alt="" />
        <!-- <img v-if="!isShow" src="../../assets/webImg/logo.png" alt="">
        <p>中国中铁</p> -->
      </div>
      <div class="menuBox">
        <!-- <p>中国中铁</p>  -->
        <van-icon @click="goTomenun(true)" v-if="!show" class="right-icon" name="bars" />
        <van-icon @click="goTomenun(false)" v-else class="right-icon" name="bars" />
        <!-- <van-icon name="cross" /> -->
        <!-- <ul class="menuList">
          <li :class="{'active':pageActive == 1 || pageActive == 7 }" @click="handleChange(1,'/')">首页</li>
          <li :class="{'active':pageActive == 2}" @click="handleChange(2,'/campusRecruitment')">校园招聘</li>
  
          <li :class="{'active':pageActive == 3}" @click="handleUrl">社会招聘</li>
          <li :class="{'active':pageActive == 4}" @click="handleChange(4,'/specialRecruitment')">专项招聘</li>
    
          <li :class="{'active':pageActive == 6}" @click="handleChange(6,'/askedQuestion')">常见问题</li>
        </ul> -->
      </div>
    </div>

    <!-- 通过函数指定挂载位置 -->
    <van-popup v-model="show" position="top" get-container="#app" :style="{ height: '285px', marginTop: '70px' }">
      <div class="item-menue" @click="handleChangeApp(1, '/')">首页</div>
      <div class="item-menue" @click="handleChangeApp(2, '/campusRecruitment')">校园招聘</div>
      <div class="item-menue" @click="handleUrl">社会招聘</div>
      <div class="item-menue" @click="handleChangeApp(4, '/specialRecruitment')">专项招聘</div>
      <div class="item-menue" @click="handleChangeApp(6, '/askedQuestion')">常见问题</div>
    </van-popup>

    <login-dialog :show="goLogin" @closeValue="handleCloseLogin" />
    <register-dialog :show="goRegister" @closeValue="handleCloseRegister" />
    <login-info-dialog :show="goLoginInfo" @closeValue="handleCloseLoginInfo" @loginOut="loginOut" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { getWebToken, removeWebToken } from "@/utils/auth";
import { RegexUtil } from "@/utils/base/RegexUtil";
import LoginDialog from "../../components/WebPageComponent/login/LoginDialog.vue";
import RegisterDialog from "../../components/WebPageComponent/login/RegisterDialog.vue";
import LoginInfoDialog from "../../components/WebPageComponent/login/LoginInfo.vue";

export default {
  name: "HeaderIndex",
  components: {
    LoginDialog,
    RegisterDialog,
    LoginInfoDialog,
  },
  data () {
    return {
      isActive: 1,
      isShow: true,
      show: false,
      isLogin: false,
      loginUser: "",

      goLogin: false,
      goLoginInfo: false,
      goRegister: false,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        // 监听路由变化
        console.log(to, "=======");
        if (to.path === "/") {
          this.SET_PAGE_ACTIVE(1);
        }
        if (to.path === "/campusRecruitment") {
          this.SET_PAGE_ACTIVE(2);
        }
        if (to.path === "/specialRecruitment") {
          this.SET_PAGE_ACTIVE(4);
        }
        if (to.path === "/askedQuestion") {
          this.SET_PAGE_ACTIVE(6);
        }
      },
    },
    isShowActive (val) {
      if (val != 1) {
        this.isShow = true;
      } else {
        this.isShow = true;
      }
    },
    pageActive (val) {
      setTimeout(() => {
        if (val == 1) {
          this.isShow = true;
        } else {
          this.isShow = true;
        }
        this.isPage = true;
        this.loginUser = localStorage.getItem("loginUser");
        if (!getWebToken()) {
          this.isLogin = false;
        }
      }, 200);
    },
  },
  computed: {
    ...mapGetters(["pageActive", "isShowActive"]),
  },
  created () {
    this.loginUser = localStorage.getItem("loginUser");
  },
  mounted () {
    this.loginUser = localStorage.getItem("loginUser");
    if (
      !RegexUtil.isEmpty(getWebToken()) &&
      !RegexUtil.isEmpty(this.loginUser)
    ) {
      this.isLogin = true;
    }
  },
  methods: {
    ...mapMutations({
      SET_SHOW_ACTIVE: "webPage/SET_SHOW_ACTIVE",
      SET_PAGE_ACTIVE: "webPage/SET_PAGE_ACTIVE",
    }),



    goTomenun (val) {
      this.show = val;
    },

    handleOpen (val) {
      this[val] = true;
    },
    handleCloseRegister (val) {
      if (val === "close") {
        this.goRegister = false;
        return;
      }
      if (val) {
        this.goLogin = true;
      }
      this.goRegister = false;
    },
    //社会招聘
    handleUrl () {
      window.open("https://www.crecg.com/web/rlzy65/rczp11/index.html");
    },
    handleCloseLoginInfo () {
      this.goLoginInfo = false;
    },
    handleCloseLogin (val) {
      if (val === "close") {
        this.goLogin = false;
        return;
      }
      if (val) {
        this.goLogin = false;
        this.handleOpen("goRegister");
      } else {
        setTimeout(() => {
          this.loginUser = localStorage.getItem("loginUser");
          if (
            !RegexUtil.isEmpty(getWebToken()) &&
            !RegexUtil.isEmpty(this.loginUser)
          ) {
            this.isLogin = true;
          }
          this.goLogin = false;
        }, 200);
      }
    },
    handleChange (val, path) {
      this.SET_PAGE_ACTIVE(val);
      if (val == 1) {
        this.SET_SHOW_ACTIVE(1);
        // window.addEventListener("scroll", this.scrolling);
        this.isShow = true;
      } else {
        this.isShow = true;
      }
      this.$router.push(path);
    },

    handleChangeApp (val, path) {
      this.show = false;
      this.$router.push(path);
    },

    handleLoginOut () {
      const that = this;
      this.$confirm({
        content: "确定退出当前登录用户吗？",
        title: "提示",
        onOk () {
          removeWebToken();
          that.loginUser = null;
          that.isLogin = false;
          localStorage.setItem("loginUser", "");
          localStorage.setItem("openType", null);
          that.$router.push("/");
        },
      });
      // this.$confirm('确定退出当前登录用户吗？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {

      // }).catch(() => {});
    },

    loginOut () {
      this.loginUser = null;
      this.isLogin = false;
      localStorage.setItem("loginUser", "");
      localStorage.setItem("openType", null);
    },
  },
};
</script>

<style lang="less" scope>
.webHeaderApp {
  width: 100%;
  position: fixed;
  top: 0;
  height: @headerHeight;
  z-index: 999999999999999;

  .webHeaderContentApp {
    width: 100%;
    height: 100%;
    z-index: 999999999999999;

    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;

    .logo2 {
      display: flex;
      align-items: center;
      cursor: pointer;

      & img {
        width: 180px;
      }

      & p {
        margin: 0 0 0 10px;
        font-size: 22px;
        font-weight: 600;
      }

      .img {
        // max-width: 100px;
        //  width: 100%;
      }
    }

    .menuBox {
      position: relative;
      width: 26px;
      height: 35px;
      overflow: hidden;

      .right-icon {
        position: absolute;
        top: 0;
        left: -8px;
        font-size: 30px;
        // color: @primary;
        padding-bottom: 5px;
        // margin-right: 15px;
      }
    }

    .menuList {
      display: flex;
      align-items: center;
      list-style: none;
      margin: 0 20px 0 0;
      padding: 0;
      background-color: transparent;

      & li {
        margin: 0 30px;
        font-size: 20px;
        cursor: pointer;
        line-height: 40px;

        &.active {
          position: relative;
          font-weight: 600;

          &::after {
            content: "";
            display: inline-block;
            width: 60%;
            height: 3px;
            border-radius: 8px;
            position: absolute;
            left: 50%;
            bottom: 0;
            -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
          }
        }
      }
    }

    .loginRegister {
      display: flex;
      align-items: center;

      & p {
        margin: 0 16px 0 0;
        font-size: @fs14;
        font-weight: 600;
        cursor: pointer;
      }

      .el-button {
        font-size: @fs14;
        border: none;
      }
    }

    .dropdownLine {
      cursor: pointer;
      display: flex;
      align-items: center;

      & img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: block;
      }

      & p {
        font-size: @fs14;
        margin: 0 0 0 10px;
        font-weight: 600;
      }

      .el-icon-arrow-down {
        &::before {
          font-weight: 600;
        }
      }
    }
  }
}

.webHeaderApp1 {
  background-color: transparent;

  .webHeaderContentApp {
    .logo2 {
      & p {
        color: @fontColorWhite;
      }
    }

    .menuList {
      li {
        color: @fontColorWhite;

        &.active {
          color: @fontColorWhite;

          &::after {
            background-color: @fontColorWhite;
          }
        }
      }
    }

    .loginRegister {
      & p {
        color: @fontColorWhite;
      }

      .el-button {
        background-color: @fontColorWhite;
        color: @primary;
      }
    }

    .dropdownLine {
      & p {
        color: @fontColorWhite;
      }

      .anticon-down {
        color: @fontColorWhite;
        margin-left: 6px;
      }
    }
  }
}

.webHeaderApp2 {
  background-color: @fontColorWhite;

  .webHeaderContentApp {
    .logo2 {
      & p {
        color: @primary;
      }
    }

    .menuList {
      li {
        color: #333333;

        &.active {
          color: @primary;

          &::after {
            background-color: @primary;
          }
        }
      }
    }

    .loginRegister {
      & p {
        color: #333333;
      }

      .el-button {
        background-color: @primary;
        color: @fontColorWhite;
      }
    }

    .dropdownLine {
      & p {
        color: #333333;
      }

      .anticon-down {
        color: #333333;
        margin-left: 6px;
      }
    }
  }
}

.item-menue {
  text-align: center;
  font-size: 16px;
  padding: 16px 0;
  // color: @primary;
  border-bottom: rgba(220, 222, 224, 1) solid 1px;
  font-weight: 600;
  cursor: pointer;
}
</style>
